import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import { Add, KeyboardArrowUp, KeyboardArrowDown } from '@mui/icons-material';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import HomeIcon from '@mui/icons-material/Home';
import { Box, Button, Collapse, FormControl, IconButton, LinearProgress, Link, MenuItem, Select, TextField, Tooltip, Typography } from "@mui/material";
import FilterListIcon from '@mui/icons-material/FilterList';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
// import { DataGrid, GridColDef, GridRenderCellParams, GridToolbarFilterButton } from '@mui/x-data-grid';
import moment from "moment";
import { format } from "date-fns";
import React, { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { config } from "../../Constants";
import useAuth from "../../context/AuthProvider";
import { AddEditTaxFeeDate, TaxesAndFeeDataModel } from "../AddEdit/AddEditTaxFeeDate";
import { AddEditFilingScheduleAdmin } from "../AddEdit/AddEditFilingScheduleAdmin";
import { RiExpandUpDownLine } from 'react-icons/ri';
import { DataGridPro, GridColDef, GridRenderCellParams, GridRowId, GridCallbackDetails } from '@mui/x-data-grid-pro';
import { apiClient } from '../../helper/api';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import { FilingScheduleAdminSummary } from '../Elements/FilingScheduleAdminSummary';

export interface FilingScheduleStateOption {
    stateId: number;
    stateName: string;
    postalAbbv: string;
}

// Extended interface for the list component
interface TaxesAndFeeListDataModel extends TaxesAndFeeDataModel {
    taxFeeAndFilingPeriod?: string;
    periodTypePending?: string;
    isActive?: boolean | number;
}

const PERIOD_TYPE_OPTIONS = ['Monthly', 'Quarterly', 'Semi-Annual', 'Annual'] as const;

function scheduleRowIsActive(row: TaxesAndFeeListDataModel): boolean {
    const v = row.isActive;
    if (v === false || v === 0) return false;
    return true;
}

function filterFilingScheduleRows(
    rows: TaxesAndFeeListDataModel[],
    filterState: string,
    filterStatus: string,
    filterPeriod: string,
    filterSearch: string,
): TaxesAndFeeListDataModel[] {
    const q = filterSearch.trim().toLowerCase();
    return rows.filter((r) => {
        if (filterState && r.stateName !== filterState) return false;
        if (filterStatus === 'active' && !scheduleRowIsActive(r)) return false;
        if (filterStatus === 'inactive' && scheduleRowIsActive(r)) return false;
        const effectivePeriod = (r.periodTypePending || r.periodType || '').trim();
        const currentPeriod = (r.periodType || '').trim();
        if (filterPeriod && currentPeriod !== filterPeriod && effectivePeriod !== filterPeriod) return false;
        if (q) {
            const name = (r.name || '').toLowerCase();
            const state = (r.stateName || '').toLowerCase();
            if (!name.includes(q) && !state.includes(q)) return false;
        }
        return true;
    });
}

interface Iprops {
    taxesAndFeeList: TaxesAndFeeListDataModel[],
    fetchData: () => void
    states: FilingScheduleStateOption[]
    sortModel: any;
    setSortModel: React.Dispatch<React.SetStateAction<any>>;
}

export const TaxesAndFeeScheduleList: React.FC<Iprops> = ({ taxesAndFeeList, fetchData, states, sortModel, setSortModel }) => {
    const [loading, setloading] = useState(false);
    const { user } = useAuth();
    const token = user?.token;
    const navigate = useNavigate();
    const goBack = () => {
        navigate(-1);
    }

    const [RadioSelectedValue, setRadioSelectedValue] = React.useState<string>('');
    const [RadioSelectedValueZeroFiling, setRadioSelectedValueZeroFiling] = React.useState<string>('');
    const [RadioSelectValueDueImmediatlyUponInvoicing, setRadioSelectedValueDueImmeditaly] = React.useState<string>('');

    let inivalue: TaxesAndFeeDataModel = {
        paymentFilingScheduleId: 0,
        stateId: 0,
        taxFeename: "",
        taxesAndFeesFilingSchedulePeriodId: 0,
        jan: "",
        feb: "",
        mar: "",
        apr: "",
        may: "",
        june: "",
        july: "",
        aug: "",
        sept: "",
        nov: "",
        oct: "",
        dec: "",
        annualDate: "",
        quarter1: "",
        quarter2: "",
        quarter3: "",
        quarter4: "",
        semiAnnualFirstHalf: "",
        semiAnnualSecondHalf: "",
        zeroFiling: "",
        stateName: "",
        taxesAndFilingSchedulePeriodId: 0,
        monthlyReportingDueDate: "",
        withInDays: "",
        withInForteenDays: false,
        dueImmediatelyUponInvoicing: false,
        payment: false,
        report: false,
        wetSignature: false,
        notaryStamp: false,
        zeroIndividual: false,
        zeroEntity: false,
        paymentType: '',
        notes: '',
        dueDate: '',
        name: ''
    }

    const [open, setOpen] = useState<boolean>(false);
    const [adminEditOpen, setAdminEditOpen] = useState(false);
    const [adminEditScheduleId, setAdminEditScheduleId] = useState<number | null>(null);
    const [adminEditInitialStateId, setAdminEditInitialStateId] = useState(0);
    const [formData, setFormData] = useState<TaxesAndFeeDataModel>(inivalue);
    const [detailPanelData, setDetailPanelData] = useState<{[key: string]: any}>({});
    const [expandedRowIds, setExpandedRowIds] = useState<GridRowId[]>([]);
    const [adminSummaryVersion, setAdminSummaryVersion] = useState(0);
    const [filterState, setFilterState] = useState('');
    const [filterStatus, setFilterStatus] = useState('');
    const [filterPeriod, setFilterPeriod] = useState('');
    const [filterSearch, setFilterSearch] = useState('');
    const [filtersExpanded, setFiltersExpanded] = useState(true);
    const [pageSize, setPageSize] = useState(25);

    const stateFilterOptions = useMemo(() => {
        const fromApi = states
            .filter((s) => s.postalAbbv)
            .map((s) => s.postalAbbv)
            .sort();
        if (fromApi.length > 0) return fromApi;
        const abbrs = taxesAndFeeList
            .map((r) => r.stateName)
            .filter((name): name is string => Boolean(name));
        return Array.from(new Set(abbrs)).sort();
    }, [states, taxesAndFeeList]);

    const filteredRows = useMemo(
        () => filterFilingScheduleRows(taxesAndFeeList, filterState, filterStatus, filterPeriod, filterSearch),
        [taxesAndFeeList, filterState, filterStatus, filterPeriod, filterSearch],
    );

    const resolveInitialStateIdForAdd = (): number => {
        if (!filterState) return 0;
        const match = states.find((s) => s.postalAbbv === filterState);
        return match?.stateId ?? 0;
    };

    const filterFieldSx = {
        '& .MuiInputBase-root': { marginTop: '5px !important' },
        '& .MuiOutlinedInput-root': { padding: '4.5px 9px' },
        '& .MuiOutlinedInput-notchedOutline': { borderColor: '#e2e8f0' },
        '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: 'rgba(0, 0, 0, 0.87)' },
        '& .Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: '#1976d2 !important' },
    };

    const fetchTaxSchedulesById = (paymentFilingScheduleId: Number) => {

        apiClient(`/TaxesAndFeesFilingSchedule/getTaxesAndFilingScheduleById?paymentFilingScheduleId=${paymentFilingScheduleId}`,


            {
                method: "GET",
                headers: new Headers({
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`,
                })
            })
            .then((responseJson) => {
                // Do something with the response

                if (responseJson?.data != null) {

                    handClickOpen(responseJson.data);
                    console.log("feild data", responseJson)
                }

            })
    }

    const fetchFilingScheduleDetails = (scheduleId: number) => {
        console.log("=== FETCHING FILING SCHEDULE DETAILS FOR DETAIL PANEL ===");
        console.log("Schedule ID:", scheduleId);
        
        const url = `/TaxesAndFeesFilingSchedule/getFilingScheduleDetails?scheduleId=${scheduleId}`;
        const headers = new Headers({
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
        });
        
        console.log("=== REQUEST DETAILS ===");
        console.log("Full URL:", config + url);
        console.log("Method: GET");
        console.log("Headers:", {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
        });
        console.log("Token:", token);
        console.log("Token length:", token?.length);
        console.log("Token starts with:", token?.substring(0, 20) + "...");
        console.log("=== END REQUEST DETAILS ===");
        
        return apiClient(url, {
            method: "GET",
            headers: headers,
        })
            .then((responseJson) => {
                console.log("=== FILING SCHEDULE DETAILS RESPONSE FOR DETAIL PANEL ===");
                console.log("Full Response:", responseJson);
                console.log("Response Status:", responseJson?.status);
                console.log("Response Message:", responseJson?.message);
                console.log("Response Data:", responseJson?.data);
                console.log("Response Data JSON:", JSON.stringify(responseJson?.data, null, 2));
                console.log("=== END FILING SCHEDULE DETAILS RESPONSE ===");
                
                return responseJson?.data || null;
            })
            .catch((error) => {
                console.error("=== ERROR FETCHING FILING SCHEDULE DETAILS ===");
                console.error("Error:", error);
                console.error("Error message:", error?.message);
                console.error("Error stack:", error?.stack);
                console.error("=== END ERROR ===");
                return null;
            });
    }

    const handleDetailPanelExpandedRowIdsChange = (newExpandedRowIds: GridRowId[], details: GridCallbackDetails) => {
        setExpandedRowIds(newExpandedRowIds);
        
        // Find newly expanded rows
        const newlyExpanded = newExpandedRowIds.filter(id => !expandedRowIds.includes(id));
        
        // Fetch data for newly expanded rows
        newlyExpanded.forEach(rowId => {
            // Find the row data by ID
            const rowData = taxesAndFeeList.find(row => 
                `${row.scheduleId || row.paymentFilingScheduleId}_${row.taxFeeAndFilingPeriod}` === rowId.toString()
            );
            
            if (rowData) {
                const scheduleId = rowData.scheduleId || rowData.paymentFilingScheduleId;
                const panelKey = rowId.toString();
                
                console.log("=== DETAIL PANEL EXPANDED ===");
                console.log("Row ID:", rowId);
                console.log("Schedule ID:", scheduleId);
                console.log("Row Data:", rowData);
                
                if (scheduleId && !detailPanelData[panelKey]) {
                    fetchFilingScheduleDetails(scheduleId).then((detailData) => {
                        if (detailData) {
                            setDetailPanelData(prev => ({
                                ...prev,
                                [panelKey]: detailData
                            }));
                        }
                    });
                }
            }
        });
    };

    function handClickOpen(data: TaxesAndFeeDataModel) {

        //    fetchTaxSchedulesById(data.paymentFilingScheduleId) 

        setFormData(data);
        console.log("FormData", data);
        data.apr = data.apr === null ? "" : data?.apr
        data.jan = data.jan === null ? "" : data?.jan
        data.feb = data.feb === null ? "" : data?.feb
        data.mar = data.mar === null ? "" : data?.mar
        data.may = data.may === null ? "" : data?.may
        data.june = data.june === null ? "" : data?.june
        data.july = data.july === null ? "" : data?.july
        data.aug = data.aug === null ? "" : data?.aug
        data.sept = data.sept === null ? "" : data?.sept
        data.oct = data.oct === null ? "" : data?.oct
        data.nov = data.nov === null ? "" : data?.nov
        data.dec = data.dec === null ? "" : data?.dec
        data.annualDate = data.annualDate === null ? "" : data?.annualDate
        data.semiAnnualFirstHalf = data.semiAnnualFirstHalf === null ? "" : data.semiAnnualFirstHalf
        data.semiAnnualSecondHalf = data.semiAnnualSecondHalf === null ? "" : data.semiAnnualSecondHalf

        data.quarter1 = data.quarter1 === null ? "" : data?.quarter1
        data.quarter2 = data.quarter2 === null ? "" : data?.quarter2
        data.quarter3 = data.quarter3 === null ? "" : data?.quarter3
        data.quarter4 = data.quarter4 === null ? "" : data.quarter4
        data.zeroFiling = data.zeroFiling === null ? "" : data.zeroFiling
        data.monthlyReportingDueDate = data.monthlyReportingDueDate === null ? "" : data.monthlyReportingDueDate
        data.withInDays = data.withInDays === null ? "" : data.withInDays
        data.withInForteenDays = data.withInForteenDays === null ? false : (data.withInForteenDays)
        data.dueImmediatelyUponInvoicing = data.dueImmediatelyUponInvoicing === null ? false : data.dueImmediatelyUponInvoicing

        data.payment = data.payment === null ? false : data.payment
        data.report = data.report === null ? false : data.report
        data.paymentType = data.paymentType === null ? "" : data.paymentType
        data.wetSignature = data.wetSignature === null ? false : data.wetSignature
        data.notaryStamp = data.notaryStamp === null ? false : data.notaryStamp
        data.zeroEntity = data.zeroEntity === null ? false : data.zeroEntity
        data.zeroIndividual = data.zeroIndividual === null ? false : data.zeroIndividual
        data.stateId = data.stateId
        data.paymentFilingScheduleId = data.paymentFilingScheduleId

        setRadioSelectedValue(data.taxesAndFilingSchedulePeriodId?.toString());

        setRadioSelectedValueZeroFiling(data.zeroFiling?.toString() != '' ? "7" : '');
        console.log("openData", data)
        setOpen(true);
    }
    function handleClickClose() {
        setFormData(inivalue);
        setOpen(false)
        fetchData();
    }

    const handleDelete = (id: number) => {
        Swal.fire({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            // icon: null, // Remove the icon property
            iconHtml: '<svg width="70" height="70" viewBox="0 0 62 62" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="31" cy="31" r="31" fill="#02A4E3"/><path d="M31.0003 25.6667V31M31.0003 36.3334H31.0137M44.3337 31C44.3337 38.3638 38.3641 44.3334 31.0003 44.3334C23.6365 44.3334 17.667 38.3638 17.667 31C17.667 23.6362 23.6365 17.6667 31.0003 17.6667C38.3641 17.6667 44.3337 23.6362 44.3337 31Z" stroke="white" strokeWidth="2" stroke-linecap="round" stroke-linejoin="round"/></svg>',
            showCancelButton: true,
            confirmButtonColor: '#02A4E3',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Delete',
            customClass: {
                confirmButton: 'btn-radius',
                cancelButton: 'btn-radius',
                popup: 'card-radius'
            }
        })
            .then((result) => {
                if (result.isConfirmed) {
                    apiClient("/TaxesAndFeesFilingSchedule/Delete?id=" + `${id}`,
                        {
                            headers: new Headers({
                                'Content-Type': 'application/json',
                                'Authorization': `Bearer ${token}`,
                            }),
                            method: "Delete",
                        }
                    )
                        .then((res) => {
                            if (!res) return
                            Swal.fire(
                                'Deleted!',
                                'Your file has been deleted.',
                                'success'
                            )
                            fetchData();
                            setOpen(false);
                        })

                }
            })



    };










    const columns: GridColDef[] = [
        {
            field: 'Edit', flex: 0.8, headerName: "Action", headerAlign: 'center', align: 'center', hideSortIcons: true, 
            sortable: false,
            disableColumnMenu: true, minWidth: 100, renderCell: (params) => {
                return (<div className='' >
                    <IconButton
                        color="primary"
                        onClick={() => {
                            const sid = params.row.scheduleId || params.row.paymentFilingScheduleId;
                            if (sid) {
                                setAdminEditScheduleId(Number(sid));
                                setAdminEditOpen(true);
                            }
                        }}
                        sx={{ color: 'rgba(255,255,255,0.9)', '&:hover': { color: '#fff', backgroundColor: 'rgba(32,153,210,0.15) !important' } }}
                    >
                        <Tooltip
                            title="Edit"
                            placement="top"
                            arrow
                        >
                            <EditOutlinedIcon fontSize="small" color="primary" />
                        </Tooltip>

                    </IconButton>
                    {user?.userRoles.split(",").includes("Super Admin") ?
                        <IconButton
                            color="error"
                            onClick={() => { handleDelete(params.row.scheduleId || params.row.paymentFilingScheduleId); }}
                            sx={{ color: 'rgba(255,255,255,0.9)', '&:hover': { color: '#fff', backgroundColor: 'rgba(211,48,47,0.15) !important' } }}
                        >
                            <Tooltip
                                title="Delete"
                                placement="top"
                                arrow
                            >
                                <DeleteOutlineOutlinedIcon fontSize="small" color="error" />
                            </Tooltip>

                        </IconButton>
                        :
                        ""}
                </div>);
            }
        },
        {
            field: 'stateName', type: 'text', headerName: 'State Name', flex: 0.7, hideSortIcons: true, minWidth: 150, renderHeader: (params) => {
                const sortItem = sortModel.find(
                    (item: any) => item.field === 'stateName'
                  );
            
                const isSortedAsc = sortItem?.sort === 'asc';
                const isSortedDesc = sortItem?.sort === 'desc'
                return (
                <div>
                    <span className="table-card-title" >{params.colDef.headerName}</span>
                    {isSortedAsc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px', color: '#999999'}} /></span> : isSortedDesc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px', color: '#999999'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px'}} /></span> : <span className=""><RiExpandUpDownLine /></span>}
                </div>
            )
            }, headerAlign: 'left', align: 'left'
        },

        {
            field: 'dueDate', type: 'text', headerName: 'Due Date', flex: 0.6, hideSortIcons: true, minWidth: 150, renderHeader: (params) => {
                const sortItem = sortModel.find(
                    (item: any) => item.field === 'dueDate'
                  );
            
                const isSortedAsc = sortItem?.sort === 'asc';
                const isSortedDesc = sortItem?.sort === 'desc'
                return (
                    <div>
                        <span className="table-card-title" >{params.colDef.headerName}</span>
                        {isSortedAsc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px', color: '#999999'}} /></span> : isSortedDesc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px', color: '#999999'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px'}} /></span> : <span className=""><RiExpandUpDownLine /></span>}
                    </div>
                )
            }, headerAlign: 'left', align: 'left', valueGetter: (params) => {
                const raw = params.row.dueDate;
                if (!raw) return '';
                if (moment.utc(raw, 'YYYY-MM-DD', true).isValid()) {
                    return moment.utc(raw, 'YYYY-MM-DD', true).format('MM/DD/YYYY');
                }
                if (moment.utc(raw, 'MM/DD/YYYY', true).isValid()) {
                    return moment.utc(raw, 'MM/DD/YYYY', true).format('MM/DD/YYYY');
                }
                return String(raw);
            },
        },


        {
            field: 'name', type: 'text', headerName: 'Name', flex: 1.8, hideSortIcons: true, minWidth: 250, renderHeader: (params) => {
                const sortItem = sortModel.find(
                    (item: any) => item.field === 'name'
                  );
            
                const isSortedAsc = sortItem?.sort === 'asc';
                const isSortedDesc = sortItem?.sort === 'desc'
                return (
                    <div>
                        <span className="table-card-title" >{params.colDef.headerName}</span>
                        {isSortedAsc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px', color: '#999999'}} /></span> : isSortedDesc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px', color: '#999999'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px'}} /></span> : <span className=""><RiExpandUpDownLine /></span>}
                    </div>
                )
            }, headerAlign: 'left', align:'left',
            renderCell: (params) => (
                <span style={{wordBreak: 'break-word' , whiteSpace:'normal', textAlign: 'left'}}>{params.row.name}</span>
            ) 
            },

        {
            field: 'payment', type: 'text', headerName: 'Payment', flex: 0.6, hideSortIcons: true, minWidth: 110, sortable: false, renderHeader: (params) => (
                <div>
                    <span className="table-card-title" >{params.colDef.headerName}</span>
                    <RiExpandUpDownLine />
                </div>
            ), headerAlign: 'left', align: 'center', valueGetter: (params) => (params.row.payment ? "X" : "")
        },
        {
            field: 'report', type: 'text', headerName: 'Report', flex: 0.5, hideSortIcons: true, minWidth: 90, sortable: false,
            renderHeader: (params) => (
                <div>
                    <span className="table-card-title" >{params.colDef.headerName}</span>
                    <RiExpandUpDownLine />
                </div>
            ), headerAlign: 'left', align: 'center', valueGetter: (params) => (params.row.report ? "X" : "")
        },
        {
            field: 'paymentType', type: 'text', headerName: 'Payment Type', flex: 0.9, headerAlign: 'left', hideSortIcons: true, minWidth: 170,
            renderHeader: (params) => {
                const sortItem = sortModel.find(
                    (item: any) => item.field === 'paymentType'
                  );
            
                const isSortedAsc = sortItem?.sort === 'asc';
                const isSortedDesc = sortItem?.sort === 'desc'
                return (
                <div>
                    <span className="table-card-title" >{params.colDef.headerName}</span>
                    {isSortedAsc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px', color: '#999999'}} /></span> : isSortedDesc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px', color: '#999999'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px'}} /></span> : <span className=""><RiExpandUpDownLine /></span>}
                    </div>
                )
            }, align: 'left'
        },
        {
            field: 'wetSignature', type: 'text', headerName: 'Wet Signature', flex: 0.8, hideSortIcons: true, minWidth: 150, sortable: false,
            renderHeader: (params) => (
                <div>
                    <span className="table-card-title" >{params.colDef.headerName}</span>
                    <RiExpandUpDownLine />
                </div>
            ), headerAlign: 'left', align: 'center', valueGetter: (params) => (params.row.wetSignature ? "X" : "")
        },
        {
            field: 'notaryStamp', type: 'text', headerName: 'Notary Stamp', flex: 0.8, hideSortIcons: true, minWidth: 150, sortable: false,
            renderHeader: (params) => (
                <div>
                    <span className="table-card-title" >{params.colDef.headerName}</span>
                    <RiExpandUpDownLine />
                </div>
            ), headerAlign: 'left', align: 'center', valueGetter: (params) => (params.row.notaryStamp ? "X" : "")
        },
        {
            field: 'zeroIndividual', type: 'text', headerName: 'Zero Individual', flex: 0.9, hideSortIcons: true, minWidth: 150, sortable: false,
            renderHeader: (params) => (
                <div>
                    <span className="table-card-title" >{params.colDef.headerName}</span>
                    <RiExpandUpDownLine />
                </div>
            ), headerAlign: 'left', align: 'center', valueGetter: (params) => (params.row.zeroIndividual ? "X" : "")
        },
        {
            field: 'notes', type: 'text', headerName: 'Notes', hideSortIcons: true, minWidth: 200,
            renderHeader: (params) => {
                const sortItem = sortModel.find(
                    (item: any) => item.field === 'notes'
                  );
            
                const isSortedAsc = sortItem?.sort === 'asc';
                const isSortedDesc = sortItem?.sort === 'desc'
                return (
                <div>
                    <span className="table-card-title" >{params.colDef.headerName}</span>
                    {isSortedAsc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px', color: '#999999'}} /></span> : isSortedDesc ? <span className="d-inline-flex flex-column table-card-title"><KeyboardArrowUp style={{ fontSize: '16px', color: '#999999'}} /> <KeyboardArrowDown style={{ fontSize: '16px', marginTop: '-9px'}} /></span> : <span className=""><RiExpandUpDownLine /></span>}
                    </div>
                )
            }, headerAlign: 'left', align: 'left', flex: 1.6
        },

        {
            field: 'zeroEntity', type: 'text', headerName: 'Zero Entity', flex: 0.7, hideSortIcons: true, minWidth: 150, sortable: false,
            renderHeader: (params) => (
                <div>
                    <span className="table-card-title" >{params.colDef.headerName}</span>
                    <RiExpandUpDownLine />
                </div>
            ), headerAlign: 'left', align: 'center', valueGetter: (params) => (params.row.zeroEntity ? "X" : "")
        },
    ];
    useEffect(() => {
        fetchData();

    }, [])

    return (
        <Box>
            <div style={{ height: "calc(100vh - 170px)", display: "flex", flexDirection: "column", width: "100%" }}>
                <Box
                    sx={{
                        flex: 1,
                        display: 'flex',
                        flexDirection: 'column',
                        minHeight: 0,
                        borderRadius: '12px',
                        overflow: 'hidden',
                        boxShadow: '0 4px 24px rgba(15, 23, 42, 0.08), 0 1px 3px rgba(15, 23, 42, 0.06)',
                        border: '1px solid #e2e8f0',
                        backgroundColor: '#ffffff',
                    }}
                >
                    <Box
                        sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            borderBottom: '1px solid #e2e8f0',
                            backgroundColor: '#fafbfc',
                        }}
                    >
                        <Box
                            sx={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'flex-start',
                                gap: 2,
                                px: 2,
                                py: 1.5,
                                flexWrap: 'wrap',
                            }}
                        >
                            <Box>
                                <Typography variant="h6" sx={{ fontWeight: 600, color: '#0f172a', fontSize: '1.125rem', lineHeight: 1.3 }}>
                                    State Report Due Dates
                                </Typography>
                                <Typography variant="body2" sx={{ color: '#64748b', mt: 0.25 }}>
                                    Filing schedule — Period Type is now editable with effective date controls
                                </Typography>
                            </Box>
                            <Box
                                className="filter-grid"
                                sx={{ display: 'flex', alignItems: 'center', gap: 1.25, flexWrap: 'wrap' }}
                            >
                                <Typography component="span" className="formtexthelper-heading" sx={{ color: '#64748b', fontWeight: 600, fontSize: '13px' }}>
                                    State
                                </Typography>
                                <FormControl size="small" sx={{ minWidth: 120, ...filterFieldSx }}>
                                    <Select
                                        value={filterState}
                                        displayEmpty
                                        autoWidth
                                        onChange={(e) => setFilterState(e.target.value)}
                                        className="border-round custom-menu-item"
                                        IconComponent={ExpandMoreIcon}
                                    >
                                        <MenuItem value="" className="custom-menu-item">All states</MenuItem>
                                        {stateFilterOptions.map((abbr) => (
                                            <MenuItem key={abbr} value={abbr} className="custom-menu-item">
                                                {abbr}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                                <Typography component="span" className="formtexthelper-heading" sx={{ color: '#64748b', fontWeight: 600, fontSize: '13px' }}>
                                    Status
                                </Typography>
                                <FormControl size="small" sx={{ minWidth: 100, ...filterFieldSx }}>
                                    <Select
                                        value={filterStatus}
                                        displayEmpty
                                        autoWidth
                                        onChange={(e) => setFilterStatus(e.target.value)}
                                        className="border-round custom-menu-item"
                                        IconComponent={ExpandMoreIcon}
                                    >
                                        <MenuItem value="" className="custom-menu-item">All</MenuItem>
                                        <MenuItem value="active" className="custom-menu-item">Active</MenuItem>
                                        <MenuItem value="inactive" className="custom-menu-item">Inactive</MenuItem>
                                    </Select>
                                </FormControl>
                                <Link
                                    component="button"
                                    type="button"
                                    underline="none"
                                    onClick={() => setFiltersExpanded((open) => !open)}
                                    className="filter-blue filter-blue-1"
                                    sx={{
                                        display: 'inline-flex',
                                        alignItems: 'center',
                                        gap: 0.5,
                                        cursor: 'pointer',
                                        textTransform: 'uppercase',
                                        fontWeight: 700,
                                        fontSize: '14px',
                                        color: '#02A4E3',
                                        border: 'none',
                                        background: 'none',
                                        px: 0.5,
                                        '&:hover': { color: '#176990' },
                                    }}
                                >
                                    <FilterListIcon sx={{ fontSize: 18 }} />
                                    Filters
                                </Link>
                                <Button
                                    variant="contained"
                                    size="medium"
                                    onClick={() => {
                                        setAdminEditScheduleId(null);
                                        setAdminEditInitialStateId(resolveInitialStateIdForAdd());
                                        setAdminEditOpen(true);
                                    }}
                                    startIcon={<Add />}
                                    sx={{
                                        textTransform: 'none',
                                        fontWeight: 600,
                                        backgroundColor: '#2099d2',
                                        '&:hover': { backgroundColor: '#176990' },
                                    }}
                                >
                                    Add new
                                </Button>
                            </Box>
                        </Box>
                        <Collapse in={filtersExpanded}>
                            <Box
                                className="filter-grid"
                                sx={{
                                    display: 'flex',
                                    gap: 1.5,
                                    px: 2,
                                    pb: 1.5,
                                    flexWrap: 'wrap',
                                    alignItems: 'center',
                                }}
                            >
                                <FormControl size="small" sx={{ minWidth: 180, ...filterFieldSx }}>
                                    <Select
                                        value={filterPeriod}
                                        displayEmpty
                                        onChange={(e) => setFilterPeriod(e.target.value)}
                                        className="border-round custom-menu-item"
                                        IconComponent={ExpandMoreIcon}
                                    >
                                        <MenuItem value="" className="custom-menu-item">All period types</MenuItem>
                                        {PERIOD_TYPE_OPTIONS.map((p) => (
                                            <MenuItem key={p} value={p} className="custom-menu-item">
                                                {p}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                                <TextField
                                    size="small"
                                    placeholder="Search state or report name…"
                                    value={filterSearch}
                                    onChange={(e) => setFilterSearch(e.target.value)}
                                    className="border-round"
                                    sx={{
                                        flex: 1,
                                        minWidth: 220,
                                        ...filterFieldSx,
                                        '& .MuiInputBase-input': {
                                            padding: '4.5px 9px !important',
                                            height: '19px',
                                        },
                                    }}
                                />
                            </Box>
                        </Collapse>
                    </Box>
                    <DataGridPro
                        getRowId={(r) => (r.scheduleId || r.paymentFilingScheduleId) + '_' + r.taxFeeAndFilingPeriod}
                        rows={filteredRows}
                        columns={columns}
                        pagination
                        rowsPerPageOptions={[25, 50, 100]}
                        pageSize={pageSize}
                        onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
                        disableColumnResize={false}
                        sortModel={sortModel}
                        onSortModelChange={(newSortModel) => setSortModel(newSortModel)}
                        onDetailPanelExpandedRowIdsChange={handleDetailPanelExpandedRowIdsChange}
                        getDetailPanelContent={({ row }) => {
                            const data = row as any; // Use any to access the actual API response fields
                            const scheduleId = data.scheduleId || data.paymentFilingScheduleId;
                            const panelKey = `${scheduleId}_${data.taxFeeAndFilingPeriod}`;
                            
                            const detailData = detailPanelData[panelKey];
                            
                            // Show loading if data is being fetched
                            if (!detailData) {
                                return (
                                    <Box sx={{ p: 2, backgroundColor: '#f5f5f5', textAlign: 'center' }}>
                                        <Typography variant="body2">Loading filing schedule details...</Typography>
                                        <LinearProgress sx={{ mt: 1 }} />
                                    </Box>
                                );
                            }
                            
                            // Use the detail data from the API response
                            // The API returns an array of objects with period-specific data
                            let detailRows: any[] = [];
                            
                            if (Array.isArray(detailData)) {
                                // Map the API response data directly
                                detailRows = detailData.map((item: any) => ({
                                    dueDate: item.dueDate,
                                    period: item.period.toString(),
                                    periodLabel: item.timePeriod || `Period ${item.period}`,
                                    timeAdd: item.timeAdd,
                                    periodType: item.periodType,
                                    endOfMonth: item.endOfMonth,
                                    alwaysOn: item.alwaysOn,
                                    setDay: item.setDay,
                                    skip: item.skip,
                                    timePeriod: item.timePeriod
                                }));
                            } else {
                                // Fallback if detailData is not an array
                                detailRows = [{
                                    dueDate: data.dueDate || 'N/A',
                                    period: '1',
                                    periodLabel: 'Default',
                                    timeAdd: detailData?.timeAdd,
                                    periodType: detailData?.periodType,
                                    endOfMonth: detailData?.endOfMonth,
                                    alwaysOn: detailData?.alwaysOn,
                                    setDay: detailData?.setDay,
                                    skip: detailData?.skip,
                                    timePeriod: detailData?.timePeriod
                                }];
                            }

                            const headerCellSx = {
                                fontWeight: 600,
                                fontSize: '12px',
                                letterSpacing: '0.05em',
                                textTransform: 'uppercase' as const,
                                color: '#64748b',
                                lineHeight: 1.35,
                            };
                            const bodyCellSx = {
                                fontSize: '14px',
                                color: '#334155',
                                lineHeight: 'normal',
                                py: 1,
                            };

                            return (
                                <Box sx={{
                                    marginLeft: '65px',
                                    width: 'calc(100% - 65px)',
                                    border: '1px solid #e2e8f0',
                                    borderRadius: '4px',
                                    maxHeight: 'calc(100% - 8px)',
                                    overflow: 'auto',
                                }}>
                                    <Box sx={{
                                        display: 'grid',
                                        gridTemplateColumns: '1fr 1fr 1fr 1fr 1fr 2fr',
                                        gap: 1,
                                        px: 2,
                                        alignItems: 'center',
                                        minHeight: '52px',
                                        backgroundColor: '#f8fafc',
                                        // borderTop: '2px solid #e2e8f0',
                                        borderBottom: '2px solid #e2e8f0',
                                        borderRadius: '4px 4px 0 0',
                                        width: '100%',
                                    }}>
                                        <Typography component="span" align="left" sx={headerCellSx}>Due Date</Typography>
                                        <Typography component="span" align="left" sx={headerCellSx}>Period Type</Typography>
                                        <Typography component="span" align="left" sx={headerCellSx}>Period</Typography>
                                        <Typography component="span" align="left" sx={headerCellSx}>End of Month</Typography>
                                        <Typography component="span" align="left" sx={headerCellSx}>Skip</Typography>
                                        <Typography component="span" align="left" sx={headerCellSx}>Time Period</Typography>
                                    </Box>

                                    {detailRows.map((detailRow, index) => (
                                        <Box
                                            key={index}
                                            sx={{
                                                display: 'grid',
                                                gridTemplateColumns: '1fr 1fr 1fr 1fr 1fr 2fr',
                                                gap: 1,
                                                px: 2,
                                                py: 1,
                                                backgroundColor: index % 2 === 1 ? '#fafbfc' : '#ffffff',
                                                transition: 'background-color 0.15s ease',
                                                borderBottom: '1px solid #f1f5f9',
                                                width: '100%',
                                                '&:hover': {
                                                    backgroundColor: '#f1f5f9',
                                                },
                                            }}
                                        >
                                            <Typography align="left" sx={bodyCellSx}>
                                                {detailRow.dueDate && detailRow.dueDate !== ''
                                                    ? moment.utc(detailRow.dueDate).isValid()
                                                        ? moment.utc(detailRow.dueDate).format('MM/DD/YYYY')
                                                        : 'Invalid Date'
                                                    : 'N/A'}
                                            </Typography>
                                            <Typography align="left" sx={bodyCellSx}>{detailRow.periodType || 'N/A'}</Typography>
                                            <Typography align="left" sx={bodyCellSx}>{detailRow.period}</Typography>
                                            <Typography align="left" sx={bodyCellSx}>{detailRow.endOfMonth ? 'Yes' : (detailRow.endOfMonth === false ? 'No' : 'N/A')}</Typography>
                                            <Typography align="left" sx={bodyCellSx}>{detailRow.skip ? 'Yes' : (detailRow.skip === false ? 'No' : 'N/A')}</Typography>
                                            <Typography align="left" sx={bodyCellSx}>{detailRow.timePeriod || 'N/A'}</Typography>
                                        </Box>
                                    ))}

                                    <Box sx={{ px: 2, pb: 1 }}>
                                        <FilingScheduleAdminSummary
                                            key={`admin-summary-${scheduleId}-${adminSummaryVersion}`}
                                            scheduleId={Number(scheduleId)}
                                        />
                                    </Box>
                                </Box>
                            );
                        }}
                        getDetailPanelHeight={() => 560}
                        sx={{
                            flex: 1,
                            minHeight: 0,
                            textAlign: 'center',
                            fontFamily: '"Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
                            border: 'none',
                            fontSize: '14px',
                            color: '#475569',
                            backgroundColor: '#ffffff',
                            whiteSpace: 'normal',
                            wordWrap: 'break-word',
                            '& .MuiDataGridPro-columnHeaderTitle': {
                                whiteSpace: 'normal',
                                lineHeight: 1.35,
                                fontWeight: 600,
                                fontSize: '12px',
                                letterSpacing: '0.05em',
                                textTransform: 'uppercase',
                                color: '#64748b',
                            },
                            '& .MuiDataGrid-columnHeaders': {
                                backgroundColor: '#f8fafc',
                                borderBottom: '2px solid #e2e8f0',
                                borderTop: '2px solid #e2e8f0',
                                minHeight: '52px !important',
                                maxHeight: '52px !important',
                            },
                            '& .MuiDataGrid-columnHeader': {
                                '&:focus, &:focus-within': { outline: 'none' },
                            },
                            '&.MuiDataGrid-root .MuiDataGrid-columnHeader--alignRight .MuiDataGrid-columnHeaderTitleContainer': {
                                pl: 1,
                            },
                            '& .MuiDataGrid-row': {
                                transition: 'background-color 0.15s ease',
                                '&:nth-of-type(even)': {
                                    backgroundColor: '#fafbfc',
                                },
                                '&:hover': {
                                    backgroundColor: '#f1f5f9 !important',
                                },
                            },
                            '& .MuiDataGrid-cell': {
                                borderBottom: '1px solid #f1f5f9',
                                fontSize: '14px',
                                color: '#334155',
                                overflow: 'visible',
                                whiteSpace: 'normal',
                                lineHeight: 'normal',
                                wordWrap: 'break-word',
                                textOverflow: 'clip',
                                padding: '8px 16px',
                                '&:focus': { outline: 'none' },
                            },
                            '& .MuiTablePagination-selectLabel, & .MuiTablePagination-displayedRows': {
                                marginBottom: '0px !important',
                            },
                            '& .MuiDataGrid-virtualScroller': {
                                border: 'none',
                            },
                            '& .MuiDataGrid-main': {
                                border: 'none',
                            },
                            '& .MuiDataGrid-footerContainer': {
                                borderTop: '1px solid #e2e8f0',
                                backgroundColor: '#f8fafc',
                                minHeight: 56,
                            },
                            '& .MuiTablePagination-root': {
                                color: '#64748b',
                                fontSize: '13px',
                            },
                            '& .MuiTablePagination-select': {
                                fontSize: '13px',
                                borderRadius: '6px',
                                border: '1px solid #e2e8f0',
                            },
                            '& .MuiIconButton-root': {
                                color: '#64748b',
                                '&:hover': {
                                    backgroundColor: '#f1f5f9',
                                    color: '#475569',
                                },
                            },
                        }}
                    />
                </Box>
                <AddEditTaxFeeDate formValues={formData} handleClose={handleClickClose} Open={open} handleSubmit={fetchData} RadioSelectedValue={RadioSelectedValue} setRadioSelectedValue={setRadioSelectedValue} RadioSelectedValueZeroFiling={RadioSelectedValueZeroFiling} setRadioSelectedValueZeroFiling={setRadioSelectedValueZeroFiling} RadioSelectValueDueImmediatlyUponInvoicing={RadioSelectValueDueImmediatlyUponInvoicing} setRadioSelectedValueDueImmeditaly={setRadioSelectedValueDueImmeditaly} />
                <AddEditFilingScheduleAdmin
                    open={adminEditOpen}
                    scheduleId={adminEditScheduleId}
                    initialStateId={adminEditInitialStateId}
                    onClose={() => {
                        setAdminEditOpen(false);
                        setAdminEditScheduleId(null);
                        setAdminEditInitialStateId(0);
                    }}
                    onSaved={() => {
                        fetchData();
                        expandedRowIds.forEach((rowId) => {
                            const rowData = taxesAndFeeList.find(
                                (row) =>
                                    `${row.scheduleId || row.paymentFilingScheduleId}_${row.taxFeeAndFilingPeriod}` ===
                                    rowId.toString(),
                            );
                            const sid = rowData?.scheduleId || rowData?.paymentFilingScheduleId;
                            if (!sid) return;
                            fetchFilingScheduleDetails(Number(sid)).then((detailData) => {
                                if (detailData) {
                                    setDetailPanelData((prev) => ({
                                        ...prev,
                                        [rowId.toString()]: detailData,
                                    }));
                                }
                            });
                        });
                        setAdminSummaryVersion((v) => v + 1);
                    }}
                />
            </div>
        </Box>
    )
}